const port = Number(process.env.REACT_APP_PORT) || '/'

module.exports = {
  servicesHostName: 'https://dindin-preprod-api.dindin-internal.com/api/',

  // required for auth redirects.
  loginUrl: `http://localhost:${port}/login`
}
